<template>
  <el-table-column
    prop="receipt_number"
    label="Bizonylatszám"
    width="160"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.receipt_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'receipt_number',
};
</script>
